import { jsx as o } from "react/jsx-runtime";
import { useMemo as L } from "react";
import E from "./styles.module.less.js";
import { MobileMenu as M } from "./mobile.js";
import { DesktopMenu as _ } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as f, canLanguageUseAtticus as g } from "../../../constants.js";
import { useScreenSize as D, WidthType as I } from "../../../utils/use-is-mobile.js";
const b = "FLOATING_CONTAINER_ID", h = "MENU_HEADER_ID", w = (N) => {
  const {
    isAuthenticated: t,
    openAuthModal: n,
    userImage: r,
    logout: i,
    hasNotifications: s,
    language: e = f,
    getTranslation: a,
    isLawyerSupported: u,
    useWill: m,
    lmpEnabled: c,
    onRequestLawyer: p,
    hideLinks: l,
    environment: d
  } = N, A = L(() => g(e) ? e : void 0, [e]);
  return D() === I.Mobile ? /* @__PURE__ */ o("div", { className: E.mobileMenuWrapper, children: /* @__PURE__ */ o(
    M,
    {
      isAuthenticated: t,
      openAuthModal: n,
      userImage: r,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: c,
      onRequestLawyer: A ? p : void 0,
      hideLinks: l,
      environment: d
    }
  ) }) : /* @__PURE__ */ o("div", { className: E.desktopMenuContainer, id: h, children: /* @__PURE__ */ o(
    _,
    {
      isAuthenticated: t,
      openAuthModal: n,
      userImage: r,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: c,
      onRequestLawyer: A ? p : void 0,
      hideLinks: l,
      environment: d
    }
  ) });
};
export {
  b as FLOATING_CONTAINER_ID,
  h as MENU_HEADER_ID,
  w as MenuComponent
};
